import { render, staticRenderFns } from "./BusinessInfoFormPanel.vue?vue&type=template&id=99af94ba&scoped=true"
import script from "./BusinessInfoFormPanel.vue?vue&type=script&lang=js"
export * from "./BusinessInfoFormPanel.vue?vue&type=script&lang=js"
import style0 from "./BusinessInfoFormPanel.vue?vue&type=style&index=0&id=99af94ba&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "99af94ba",
  null
  
)

export default component.exports